import React, { FC } from "react";
import { faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons/faTriangleExclamation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const TriangleExclamation: FC<JSX.IntrinsicAttributes> = (props) => (
  <FontAwesomeIcon icon={faTriangleExclamation} {...props} />
);
